import { completeOnboarding } from './types';

const onboardingReducerObject = {
  [completeOnboarding.request]: (state) =>
    state.withMutations((s) =>
      s
        .setIn(['onboardingCompleted', 'network', 'loading'], true)
        .setIn(['onboardingCompleted', 'network', 'error'], false),
    ),
  [completeOnboarding.success]: (state, { response }) =>
    state.withMutations((s) =>
      s
        .setIn(['onboardingCompleted', 'network', 'loading'], false)
        .setIn(['onboardingCompleted', 'network', 'error'], false)
        .setIn(['user', 'profile', 'preferences', response])
        .setIn(['user', 'profile', 'preferences', 'onboardingPreferences', response], true)
        .setIn(['user', 'profile', 'preferences', 'onboardingCompleted'], true),
    ),
  [completeOnboarding.failure]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['onboardingCompleted', 'network', 'loading'], false)
        .setIn(['onboardingCompleted', 'network', 'error'], action.error),
    ),
};

export default onboardingReducerObject;
